import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import { logout, selectUser } from "../redux/slice/auth"
import { authModalOpen } from "../redux/slice/authModal"
import { useAppSelector } from "./index"
import { useLogoutApiMutation } from "../redux/api/auth"
import { deleteCookie } from "../utils/cookies"
import { HAS_USER_OBJECT_COOKIE, USER_OBJECT_COOKIE, USER_TOKEN_EXPIR } from "../utils/constants"
import { setProjectsList } from "../redux/slice/main"

export function useLogout(): () => void {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const user = useAppSelector(selectUser)
  const [logoutApi] = useLogoutApiMutation()
  return () => {
    if (user?.id) {
      window?.Echo?.connector?.pusher?.channel("presence-mainStaq")?.trigger("client-inactiveLeave", user.id)
    }
    logoutApi().then(() => {
      window.Echo.leave(`privateUser.${user?.id}`)
      dispatch(logout())
      dispatch(setProjectsList({ projects: [] }))
      dispatch(authModalOpen({ flag: true }))
      navigate("/")
      deleteCookie(USER_TOKEN_EXPIR, {
        sameSite: "lax",
        path: process.env.NEXT_PUBLIC_ASSET_PREFIX || "/",
        expires: new Date(0),
      })
      deleteCookie(USER_OBJECT_COOKIE, {
        sameSite: "lax",
        path: process.env.NEXT_PUBLIC_ASSET_PREFIX || "/",
        expires: new Date(0),
      })
      deleteCookie(HAS_USER_OBJECT_COOKIE, {
        sameSite: "lax",
        path: process.env.NEXT_PUBLIC_ASSET_PREFIX || "/",
        expires: new Date(0),
      })
    })
  }
}
